/* eslint-disable import/no-unresolved */
import React from 'react';
import PropTypes from 'prop-types';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';

import { getImagem } from '../../utils/imagens';
import '../../assets/scss/components/BannersRotativos.scss';

const BannersRotativos = ({ banners }) => {
  if (!banners || banners.length === 0) return null;

  return (
    <section className="in-banner-rotativo-section">
      <div className="in-banner-rotativo-container">
        <Swiper
          modules={[Autoplay, Pagination]}
          spaceBetween={20}
          slidesPerView={1}
          loop={banners.length > 1}
          autoplay={{
            delay: 4000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }}
          pagination={banners.length > 1 ? { clickable: true } : false}
          className="banners-rotativos-swiper"
        >
          {banners.map((item, index) => {
            const src = getImagem(item.imagem);
            if (!src) return null;

            return (
              // eslint-disable-next-line react/no-array-index-key
              <SwiperSlide key={index} className="banner-rotativo-slide">
                {item.href ? (
                  <a
                    href={item.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="align-banner"
                  >
                    <img src={src} alt={item.alt || `Banner ${index + 1}`} />
                  </a>
                ) : (
                  <div className="align-banner">
                    <img src={src} alt={item.alt || `Banner ${index + 1}`} />
                  </div>
                )}
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </section>
  );
};

BannersRotativos.propTypes = {
  banners: PropTypes.arrayOf(
    PropTypes.shape({
      imagem: PropTypes.string.isRequired,
      alt: PropTypes.string,
      href: PropTypes.string
    })
  )
};

BannersRotativos.defaultProps = {
  banners: []
};

export default BannersRotativos;
